// extracted by css-extract-rspack-plugin
export default {"overwriteActions":"overwriteActions-TPAvex","saveActions":"saveActions-DBIlTp"};